/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconArrowDown8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowDown8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path d="m1.59 2.549 2.43 2.43 2.432-2.43.47.471-2.901 2.903L1.118 3.02l.472-.471Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconArrowDown12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowDown12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path d="M2.384 3.823 6.03 7.47l3.647-3.647.707.707L6.03 8.884 1.677 4.53l.707-.707Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconArrowDown16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowDown16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M3.178 5.098 8.04 9.96l4.862-4.862.943.942-5.805 5.805L2.235 6.04l.943-.942Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowDown20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowDown20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="m3.973 6.372 6.078 6.078 6.077-6.078 1.179 1.178-7.256 7.256L2.795 7.55l1.178-1.178Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowDown24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowDown24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="m4.768 7.646 7.292 7.294 7.293-7.294 1.415 1.415-8.708 8.707L3.354 9.06l1.414-1.415Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconArrowDown = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowDown(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconArrowDown8 {...iconProps} />;
        case '12':
            return <IconArrowDown12 {...iconProps} />;
        case '16':
            return <IconArrowDown16 {...iconProps} />;
        case '20':
            return <IconArrowDown20 {...iconProps} />;
        case '24':
            return <IconArrowDown24 {...iconProps} />;
        default:
            return <IconArrowDown24 {...iconProps} />;
    }
});
